var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.51697L7.40519 7.51697L7.40519 14L6.56687 14L6.56687 7.51697L6.25097e-07 7.51697L6.6907e-07 6.51098L6.56687 6.51098L6.56687 -3.24913e-07L7.40519 -2.88268e-07L7.40519 6.51098L14 6.51098L14 7.51697Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.51697L7.40519 7.51697L7.40519 14L6.56687 14L6.56687 7.51697L6.25097e-07 7.51697L6.6907e-07 6.51098L6.56687 6.51098L6.56687 -3.24913e-07L7.40519 -2.88268e-07L7.40519 6.51098L14 6.51098L14 7.51697Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.750b4c4d70f7c3d81e908030c7141cae.svg";
export { ForwardRef as ReactComponent };